export default __webpack_public_path__ + "static/media/SD-divider.4a9d8e76.svg";